<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../../types';
    import type {Document} from 'typings/portaro.be.types';
    import {getPageContext} from 'shared/layouts/page-context';
    import {exists} from 'shared/utils/custom-utils';
    import SutorAttendanceCalendar from '../../../../sutor/components/attendance-calendar/SutorAttendanceCalendar.svelte';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';

    export let injectedUserRecord: Document | null = null;

    const userRecord = exists(injectedUserRecord) ? injectedUserRecord : getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>().staticData.userRecord;
</script>

<div class="sutor-user-attendance-tab">
    <KpHeading type="h2">Docházka</KpHeading>
    <SutorAttendanceCalendar userRecordId="{userRecord.id}" type="month-with-summary"/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .sutor-user-attendance-tab {
        display: flex;
        flex-direction: column;
        gap: @spacing-l;
    }
</style>
